import { useContext } from 'react';
import CMSContext from '../contexts/CMSManagment';

const useCmsManagment = () => useContext(CMSContext);

export default useCmsManagment;
